import React, { Component } from 'react'; //different
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import moment from 'moment';

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            weekdays: [],
            userid: props.userid,   // only pick what you need
            weeksum: [],
            username: '',
            firstname: '',
            clicked: false,
            lastname: '',
            checkinsetting: [],
            checkinThisMonth: 0,
        }
        this.MILESTONES = [
            { days: 0, percent: 0 },
            { days: 3, percent: 25 },
            { days: 7, percent: 50 },
            { days: 15, percent: 75 },
            { days: 25, percent: 100 },
        ];
    }


    async componentDidMount() {
        console.log("componentDidMount Cardgame prevState", this.props);
        this.getcheckin(this.props.userid);

    }
    componentDidUpdate(prevProps, prevState) {
        const { point, userid } = this.props; // destructuring for easier access

        // Check if point has changed
        if (prevProps.point !== point) {
            if (point !== this.state.point) {
                console.log("componentDidUpdate - point updated:", point);
                this.setState({ point });
            }
        }

        // Check if username has changed
        if (prevProps.username !== userid) {
            if (userid !== this.state.userid) {
                console.log("componentDidUpdate - username updated:", userid);
                this.setState({ userid: userid });

            }
        }
    }


    handleCheckIn = async (item, type) => {
        console.log('Check-in item clicked:', item, type);
        this.setState({ clicked: true })

        try {
            // สร้างข้อมูลใน object.rows ที่จำเป็น
            if (type === 1) {
                const isToday = moment().isSame(moment(item.dateStr), 'day'); // เช็คว่าเป็นวันนี้
                if (isToday) {
                    const rows = {
                        userid: this.state.userid,  // user ID ที่เช็คอิน
                        dateupdate: item.dateStr,
                        CheckinID: item.weekdayIndex,
                        status: 1,  // สถานะการเช็คอิน
                        // คุณสามารถเพิ่มข้อมูลเพิ่มเติมได้ตามที่ต้องการ
                    };

                    // ส่งข้อมูลไปยัง API
                    const response = await instance.post('/api/v1/postcheckinlist', {
                        System: Systems,
                        type: type,
                        userid: this.state.userid,  // user ID ที่เช็คอิน
                        rows: rows,
                    });

                    const data = await response.data; // ใช้ .data แทน .json() ถ้าใช้ axios
                    if (data.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'เช็คอินสำเร็จ',
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }

                    else {
                        console.log('Check-in failed:', data);
                        await Swal.fire({
                            icon: 'warning',
                            title: 'เช็คอินไม่สำเร็จ',
                            text: data.message,
                        });
                        this.setState({ clicked: false })
                    }
                } else {
                    console.log('ไม่สามารถเช็คอินสำหรับวันที่นี้');
                    Swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถเช็คอินได้',
                        text: 'วันที่เช็คอินไม่ตรงกับวันนี้',
                    });
                }
            } else if (type === 2) {
                // ส่งข้อมูลไปยัง API สำหรับการรับรางวัลสะสม
                const response = await instance.post('/api/v1/postcheckinlist', {
                    System: Systems,
                    userid: this.state.userid,  // user ID ที่เช็คอิน
                    item: item,
                    type: type,
                    status: 1,  // สถานะการเช็คอิน
                });

                const data = await response.data; // ใช้ .data แทน .json() ถ้าใช้ axios
                if (data.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'รับรางวัลสะสมสำเร็จ',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } else {
                    console.log('Reward redemption failed:', data);
                    Swal.fire({
                        icon: 'warning',
                        title: 'รับรางวัลไม่สำเร็จ',
                        text: data.message,
                    });
                }
            }
        }
        catch (error) {
            console.log('Error posting checkin:', error);
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาดในการเช็คอิน',
                text: error.message || 'กรุณาลองใหม่อีกครั้ง',
            });
        }
        this.getcheckin(this.state.userid); // ดึงข้อมูลการเช็คอินล่าสุด
    };

    getcheckin = async (username) => {
              try {
            await instance.post("/api/v1/getcheckin", {
                System: Systems,
                userid: username,
            }).then((res) => {
                console.log("getcheckin", res.data)
                if (res.data.status === 200) {
                    const datas = res.data;
                    this.setState({
                        checkinThisMonth: datas.checkinThisMonth,
                        weekdays: datas.weekList.week,
                        weeksum: datas.weekList.weeksum,
                        checkinsetting: datas.tblcheckinsetting,
                    });

                }
                else {
                    // this.CheckThisGoalError();
                }
            });
        }
        catch (error) {
            console.log(error)
        }
    }
    
    getPercentByDays(days) {
        const d = Number(days || 0);
        if (d <= 0) return 0;
        if (d >= 25) return 100;

        // หา segment ที่ days อยู่ระหว่าง point i และ i+1
        for (let i = 0; i < this.MILESTONES.length - 1; i++) {
            const a = this.MILESTONES[i];
            const b = this.MILESTONES[i + 1];
            if (d >= a.days && d <= b.days) {
                // linear interpolation
                const ratio = (d - a.days) / (b.days - a.days);
                const pct = a.percent + ratio * (b.percent - a.percent);
                return Math.round(pct * 100) / 100; // ปัด 2 ตำแหน่ง
            }
        }
        return 100;
    }

    getNearestMilestone(days) {
        const d = Number(days || 0);
        let last = this.MILESTONES[0];
        for (const m of this.MILESTONES) {
            if (d >= m.days) last = m;
            else break;
        }
        return last; // คืน object {days, percent}
    }
    render() {
        const { checkinThisMonth, weeksum, checkinsetting } = this.state;

        // สิ่งที่ควรใช้เป็น totalNeeded (ถ้าจาก setting ให้ดึงจาก checkinsetting หรือ weeksum)
        const current = Number(this.state.checkinThisMonth || 0);
        const percent = this.getPercentByDays(current);
        const nearest = this.getNearestMilestone(current);

        return (
            <>
                <br></br>
                <br></br>
                <br></br>
                <div className="animated animatedFadeInUp fadeInUp mt-2">
                    <div className="row m-0 border-shadow-title" >
                        <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                            <div className="text-center bg-title-web">
                                <div>
                                    <div className="text-title text-white-v1 text-center">
                                        <div className="d-flex justify-content-between">
                                            <div className="text-white-v1-deposit">
                                                <a role="button" onClick={() => (window.location.href = '/')}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={25}
                                                        height={25}
                                                        fill="currentColor"
                                                        className="bi bi-arrow-left-circle text-color-back"
                                                        viewBox="0 0 16 16"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                        />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className="text-white-v1-deposit">
                                                <h5>กิจกรรมเชคอิน</h5>
                                            </div>
                                            <div>

                                            </div>
                                        </div>
                                        <hr className="mt-0" />
                                    </div>
                                </div>
                            </div>
                            <div className="-cover-wrapper">
                                <div
                                    className="x-daily-check-in-cover x-bg-position-center lazyloaded"
                                    data-bgset="/build/web/ezl-ae-sexy/img/check-in-cover-bg.jpg?v=3"
                                    style={{
                                        backgroundImage:
                                            'url("/build/web/ezl-ae-sexy/img/check-in-cover-bg.jpg?v=3")'
                                    }}
                                >
                                    <h1 className="-title">เช็คอินประจำวัน</h1>
                                    <div className="-condition">ทำยอดเติม {checkinsetting[0]?.credit}.- ขึ้นไป</div>
                                    <div className="-sub-title">
                                        รับทุกวันเพียงเข้ามาเช็คอิน พร้อมทั้งสะสมเพื่อรับรางวัลที่สูงขึ้น
                                    </div>
                                </div>
                            </div>
                            <div className="-main-content-wrapper js-daily-check-in-container">
                                <div >
                                    <div className="x-daily-check-in-card x-check-in-daily">
                                        <div className="-heading-wrapper">
                                            <div className="-col-left">
                                                <i className="fas fa-calendar-check" />
                                                <div className="-col-left-inner-wrapper">
                                                    <h2 className="-card-title">เช็คอินประจำวัน</h2>
                                                </div>
                                            </div>
                                            <div className="-col-right"></div>
                                        </div>
                                        <div className="-content-wrapper">
                                            <ul className="x-check-in-checked-box-list nav">
                                                {this.state.weekdays.map((item, index) => {
                                                    const m = moment(item.dateStr);            // วันที่ของไอเท็ม
                                                    const isPast = m.isBefore(moment(), 'day'); // วันก่อนวันนี้ (true ถ้าผ่านมาแล้ว)
                                                    const isToday = m.isSame(moment(), 'day');  // วันนี้หรือไม่
                                                    const isFuture = m.isAfter(moment(), 'day'); // วันในอนาคต (true ถ้ายังไม่ถึงวันนี้)
                                                    const liClass = `nav-item ${isPast ? '-is-passed' : isToday ? '-can-apply' : ''}`;

                                                    return (
                                                        <li key={item.dateStr || index} className={liClass}>
                                                            <button
                                                                onClick={() => (!item.passed) ? this.handleCheckIn(item, 1) : null}
                                                                type="button"
                                                                className={`js-check-in btn nav-link -nav-link ${isPast || isFuture || this.state.clicked ? 'disabled' : ''}`}
                                                                disabled={isPast}   // ปิดปุ่มถ้าผ่านมาแล้ว
                                                            >
                                                                <div className="-top-wrapper">
                                                                    <div className="-ic-wrapper">
                                                                        {!item.passed ? (
                                                                            <img
                                                                                alt="AE SEXY Image"
                                                                                className="img-fluid -ic"
                                                                                width={44}
                                                                                height={43}
                                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-coin.png"
                                                                            />) : (<img
                                                                                alt="AE SEXY Image"
                                                                                className="img-fluid -ic"
                                                                                width={44}
                                                                                height={43}
                                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-checked.png"
                                                                            />)}
                                                                    </div>
                                                                    <span className="-text-point">+{item.credit}</span>
                                                                </div>
                                                                <div className="-bottom-wrapper">
                                                                    <span>{isToday ? "วันนี้" : m.format('DD/MM')}</span>
                                                                </div>
                                                            </button>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="x-daily-check-in-card x-check-in-collect">
                                        <div className="-heading-wrapper">
                                            <div className="-col-left">
                                                <div className="-col-left-inner-wrapper">
                                                    <h2 className="-card-title">เช็คอินสะสมเดือนนี้</h2>
                                                    {/* <p className="-card-sub-title">อีก 3 วัน ได้รับสูงสุด ฿5</p> */}
                                                </div>
                                            </div>
                                            <div className="-col-right">
                                                <div className="x-check-in-date-counter">
                                                    <div className="-box">{checkinThisMonth}</div>
                                                    <span>วัน</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="-content-wrapper">
                                            <div className="x-check-in-collect-container">
                                                <ul className="nav x-check-in-collect-box-list">
                                                    {weeksum.map((item, index) => {
                                                        // ตรวจสอบว่า map ทำงานหรือไม่
                                                        return (
                                                            <li key={index} className={`nav-item x-check-in-collect-box-list-item ${!item.passed || item.totalday > checkinThisMonth ? '' : ' -can-apply'}`} >
                                                                <div
                                                                    onClick={() => this.handleCheckIn(item, 2)}
                                                                    type="button"
                                                                    //  className={`${item.passed ? 'disabled' : ''}`}
                                                                    className={`js-check-in nav-link -nav-link ${item.passed || item.totalday > checkinThisMonth || this.state.clicked ? 'disabled' : ''}`}
                                                                >
                                                                    <div className="-ic-wrapper">
                                                                        {!item.passed ? (
                                                                            <img
                                                                                alt="AE SEXY Image"
                                                                                className="img-fluid -ic"
                                                                                width={144}
                                                                                height={144}
                                                                                src="https://asset.cloudigame.co/build/admin/img/wt_theme/ezl/check-in-box.png"
                                                                            />) : (<img
                                                                                alt="AE SEXY Image"
                                                                                className="img-fluid -ic"
                                                                                width={44}
                                                                                height={43}
                                                                                src="https://cdn.javisx.com/image/c1daeee2-74c6-4e71-ab7c-9ae8f4c5b2d6.png"
                                                                            />)}
                                                                        <div className="-reward-detail">
                                                                            <div className="-label">สูงสุด</div>
                                                                            <div className="-value">{item.credit}฿</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="-pointer-wrapper">
                                                                        <div className="-pointer"></div>
                                                                    </div>
                                                                    <div className="-label-wrapper ">
                                                                        <span>{item.totalday} วัน</span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                                <div className="x-check-in-collect-progress">
                                                    <span className="-status-text">{current}/25</span>
                                                    <div className="-progress" style={{ width: '80%' /* คงไว้ตาม CSS ของคุณ */ }}>
                                                        {/* ใส่ percent ตรง ๆ — เป็น % ของ .-progress */}
                                                        <div className="-progress-bar" style={{ width: `${percent}%` }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );

    }
}
export default App;
